
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取收款列表
export function getCollectionsList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/payments',
    method: 'GET',
    params: parameter
  })
}

export function getCollectionList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/receivablesPayment/receipt',
    method: 'GET',
    params: parameter
  })
}

// 新增收款||编辑收款
export function controlCollection (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/payment',
    method: 'POST',
    data: parameter
  })
}
// 新增收款||编辑收款
export function getControlCollectionDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/payment',
    method: 'GET',
    params: parameter
  })
}

// 收付款删除
export function deleteCollection (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/payment',
    method: 'DELETE',
    params: parameter
  })
}

// 收款详情
export function getCollectionDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/receivablesPayment/detail',
    method: 'GET',
    params: parameter
  })
}

// 获取销售合同列表
export function getAllSellContractList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contracts/sell',
    method: 'GET',
    params: parameter
  })
}

// 获取采购合同列表
export function getAllPurchaseContractList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchase',
    method: 'GET',
    params: parameter
  })
}

// 根据合同获取项目详情
export function getContractDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/details',
    method: 'GET',
    params: parameter
  })
}

// 获取付款列表
export function getPaymentList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/receivablesPayment/payment',
    method: 'GET',
    params: parameter
  })
}

// 新增||编辑付款记录
export function controlPayment (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/receivablesPayment/payment',
    method: 'POST',
    data: parameter
  })
}

// 收付款删除
export function deleteContract (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/receivablesPayment',
    method: 'DELETE',
    params: parameter
  })
}

// 收付款锁定
export function lockContract (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/receivablesPayment',
    method: 'PUT',
    params: parameter
  })
}

// 获取经办人列表
export function getHandlerList () {
  return axios({
    url: sysInfo.apiRemote + '/user/handler',
    method: 'GET'
  })
}
